import { readSessionToken, rememberSessionToken } from "./authToken";

// Launch bootstrap reader (modules/04 §3, design/03 §1). In embedded mode the launch
// endpoint served a page exposing window.__VC_BOOTSTRAP__ bound to a callId; in
// standalone/dev mode the callId + token arrive as URL query params. Pure + unit-tested.

export interface LaunchBootstrap {
  callId: number;
  systemCode: string;
  driverId: string;
  caseRef: string;
  caseRefType: string;
  officerId: string;
  unit: string | null;
  station: string | null;
  userId: number;
  externalUserId: string;
  /** Optional session token for the hub when the host injects one. */
  token?: string;
}

export interface CallEntry {
  callId: number | null;
  token: string;
  context: LaunchBootstrap | null;
}

export interface BootstrapWindow {
  __VC_BOOTSTRAP__?: unknown;
}

declare global {
  interface Window {
    __VC_BOOTSTRAP__?: unknown;
  }
}

export function readCallEntry(win: BootstrapWindow, search: URLSearchParams): CallEntry {
  const ctx = parseBootstrap(win.__VC_BOOTSTRAP__);
  const token = ctx?.token ? rememberSessionToken(ctx.token) : readSessionToken(search);
  if (ctx) {
    return { callId: ctx.callId, token, context: ctx };
  }
  const urlCallId = Number(search.get("callId") ?? 0);
  return {
    callId: Number.isFinite(urlCallId) && urlCallId > 0 ? urlCallId : null,
    token,
    context: null
  };
}

function parseBootstrap(raw: unknown): LaunchBootstrap | null {
  if (!raw || typeof raw !== "object") return null;
  const b = raw as Record<string, unknown>;
  if (typeof b.callId !== "number" || b.callId <= 0) return null;
  return {
    callId: b.callId,
    systemCode: str(b.systemCode),
    driverId: str(b.driverId),
    caseRef: str(b.caseRef),
    caseRefType: str(b.caseRefType),
    officerId: str(b.officerId),
    unit: b.unit == null ? null : str(b.unit),
    station: b.station == null ? null : str(b.station),
    userId: typeof b.userId === "number" ? b.userId : 0,
    externalUserId: str(b.externalUserId),
    token: typeof b.token === "string" ? b.token : undefined
  };
}

const str = (v: unknown): string => (typeof v === "string" ? v : "");
